import React, { Component } from 'react';
import LeftContainer from './Components/LeftContainer';
import PhotoEditor from './Components/PhotoEditor';
import TextEditor from './Components/TextEditor';
import en from 'react-intl/locale-data/en';
import de from 'react-intl/locale-data/de';
import { omit } from 'ramda';
import { addLocaleData, defineMessages, IntlProvider } from 'react-intl';
import { Provider as AlertProvider } from 'react-alert';
import AlertTemplate from 'react-alert-template-basic';
import { getInitials, toDataURL, objectValues, getLanguage, setTextOnly } from './Utils';
import { withAlert } from 'react-alert';
import '@babel/polyfill';

addLocaleData([...en, ...de]);

Array.prototype.includes =
    Array.prototype.includes ||
    function(string) {
        return this.indexOf(string) > -1;
    };

String.prototype.includes =
    String.prototype.includes ||
    function(string) {
        return this.split('').includes(string);
    };

class App extends Component {
    state = {
        messages: this.getNewMessages(),
        locale: getLanguage(),
        language: getLanguage(),
        showText: false,
        textDefaults: {
            size: 14,
            color: '#000000',
            fontWeight: 'normal',
            font: 'Give You Glory',
            rotation: 0,
            text: '',
            textAlign: 'center',
            width: window.innerWidth < 720 ? 200 : 400,
            height: window.innerWidth < 720 ? 30 : 50
        },
        textNextId: 1,
        texts: {},
        image: {
            zoom: 1,
            rotation: 0,
            vignette: 20
        },
        listenersSet: false
    };

    componentDidUpdate(prevProps, prevState) {
        const wrapper = document.getElementById('react-avatar-wrapper');

        if (!this.state.listenersSet && wrapper) {
            wrapper.onmouseenter = this.setScrollListener;
            wrapper.onmouseleave = this.removeScrollListener;
            this.setState({ listenersSet: true });
        }
        if (prevState.language !== this.state.language) {
            this.setState({
                messages: this.getNewMessages(this.state.language)
            });
        }
    }

    addText = () => {
        this.setState(prevState => {
            const newId = prevState.textNextId;
            return {
                texts: {
                    ...prevState.texts,
                    [newId]: { ...prevState.textDefaults, id: newId }
                },
                textNextId: newId + 1
            };
        });
    };

    removeText = id => {
        this.setState({
            texts: omit([id], this.state.texts)
        });
    };

    setScrollListener = () => {
        this.oldOnScroll = window.onscroll;
        window.addEventListener('wheel', this.scrollListener);
    };

    removeScrollListener = () => {
        window.removeEventListener('wheel', this.scrollListener);
    };

    scrollListener = e => {
        e.preventDefault();
        const { deltaY } = e;
        const nextValue =
            deltaY < 0
                ? this.state.image.zoom + 0.1
                : this.state.image.zoom - 0.1;
        const parsedValue = nextValue > 0.1 ? nextValue : 0.1;
        this.setState({
            image: { ...this.state.image, zoom: parsedValue }
        });
    };

    componentDidMount() {
        const root = document.getElementById(
            'MainContent_PerfumeImageASCX_myDesign'
        );
        if (root) {
            root.setAttribute('data-submitted', 'false');
        }
        const wrapper = document.getElementById('react-avatar-wrapper');
        if (wrapper) {
            wrapper.onmouseenter = this.setScrollListener;
            wrapper.onmouseleave = this.removeScrollListener;
            this.setState({ listenersSet: true });
        }
        getInitials()
            .then(result => {
                if (!result) {
                    return alert(
                        'Something went wrong. Please try again later'
                    );
                }
                const { textLayers, frame } = result;
                toDataURL(frame.backgroundUrl).then(res =>
                    this.setState({ backgroundUrl: res })
                );
                toDataURL(frame.frontUrl).then(res =>
                    this.setState({ frontUrl: res })
                );

                this.setState(prevState => {
                    const texts = prevState.texts;
                    let textNextId = prevState.textNextId;
                    objectValues(textLayers).forEach(textLayer => {
                        texts[textNextId + 1] = {
                            id: textNextId + 1,
                            color: textLayer.fontColor,
                            size: textLayer.fontSize,
                            text: textLayer.text,
                            fontWeight: textLayer.fontStyle,
                            textAlign: textLayer.textAlign,
                            rotation: textLayer.rotationAngle,
                            positionX: textLayer.positionX,
                            positionY: textLayer.positionY,
                            font: textLayer.fontFamily,
                            width: textLayer.width,
                            height: textLayer.height
                        };
                        textNextId += 1;
                    });
                    return {
                        texts,
                        textNextId: textNextId + 1
                    };
                });
            })
            .catch(e => {
                alert('Something went wrong. Please try again later');
            });
    }

    getNewMessages(language = getLanguage()) {
        const selectedLanguage = language;
        let localizedMessages = require('./Intl/en.json');
        try {
            localizedMessages = require(`./Intl/${selectedLanguage}.json`);
        } catch (e) {}
        return defineMessages(localizedMessages);
    }

    onZoomChange = zoom => {
        this.setState({ image: { ...this.state.image, zoom } });
    };
    onVignetteChange = vignette => {
        this.setState({ image: { ...this.state.image, vignette } });
    };
    onRotationChange = rotation => {
        this.setState({ image: { ...this.state.image, rotation } });
    };

    selectFont = (id, font) => {
        const textObj = this.state.texts[id];
        this.setState({
            texts: {
                ...this.state.texts,
                [id]: {
                    ...textObj,
                    font: font.value
                }
            }
        });
    };
    selectFontWeight = (id, fontWeight) => {
        const textObj = this.state.texts[id];
        this.setState({
            texts: {
                ...this.state.texts,
                [id]: {
                    ...textObj,
                    fontWeight: fontWeight.value
                }
            }
        });
    };

    selectSize = (id, size) => {
        const textObj = this.state.texts[id];
        this.setState({
            texts: {
                ...this.state.texts,
                [id]: {
                    ...textObj,
                    size
                }
            }
        });
    };

    selectRotation = (id, rotation) => {
        if (rotation > 360 || rotation < 0) {
            return;
        }
        const textObj = this.state.texts[id];
        this.setState({
            texts: {
                ...this.state.texts,
                [id]: {
                    ...textObj,
                    rotation
                }
            }
        });
    };

    selectAlignment = (id, alignment) => {
        const textObj = this.state.texts[id];
        this.setState({
            texts: {
                ...this.state.texts,
                [id]: {
                    ...textObj,
                    textAlign: alignment.value
                }
            }
        });
    };

    selectHeight = (id, height) => {
        const textObj = this.state.texts[id];
        this.setState({
            texts: {
                ...this.state.texts,
                [id]: {
                    ...textObj,
                    height
                }
            }
        });
    };

    selectWidth = (id, width) => {
        const textObj = this.state.texts[id];
        this.setState({
            texts: {
                ...this.state.texts,
                [id]: {
                    ...textObj,
                    width
                }
            }
        });
    };

    selectColor = (id, color) => {
        const textObj = this.state.texts[id];
        this.setState({
            texts: {
                ...this.state.texts,
                [id]: {
                    ...textObj,
                    color: color.hex
                }
            }
        });
    };

    onChangeText = (id, e) => {
        const textObj = this.state.texts[id];
        this.setState({
            texts: {
                ...this.state.texts,
                [id]: {
                    ...textObj,
                    text: e.target.value
                }
            }
        });
    };

    render() {
        return (
            <IntlProvider
                locale={this.state.locale}
                messages={this.state.messages}
            >
                <AlertProvider
                    template={AlertTemplate}
                    position={'bottom center'}
                >
                    <div className="react-avatar-container">
                        <LeftContainer
                            texts={this.state.texts}
                            rotation={this.state.image.rotation}
                            zoom={this.state.image.zoom}
                            vignette={this.state.image.vignette}
                            onChangeText={this.onChangeText}
                            frontUrl={this.state.frontUrl}
                            backgroundUrl={this.state.backgroundUrl}
                            selectHeight={this.selectHeight}
                            selectWidth={this.selectWidth}
                        />
                        <div className="react-avatar-right-side-wrapper">
                            <PhotoEditor
                                onZoomChange={this.onZoomChange}
                                onVignetteChange={this.onVignetteChange}
                                onRotationChange={this.onRotationChange}
                                rotation={this.state.image.rotation}
                                zoom={this.state.image.zoom}
                                vignette={this.state.image.vignette}
                            />
                            <div className="react-avatar-right-separating-line" style={{ display: setTextOnly()=='1'?'none':'block'}}>
                                <div className="react-avatar-right-separating-line-content" />
                            </div>
                            <TextEditor
                                removeText={this.removeText}
                                showText={this.state.showText}
                                selectFont={this.selectFont}
                                selectFontWeight={this.selectFontWeight}
                                selectSize={this.selectSize}
                                selectColor={this.selectColor}
                                selectRotation={this.selectRotation}
                                selectTextAlignment={this.selectAlignment}
                                toggleText={this.toggleText}
                                addText={this.addText}
                                onChangeText={this.onChangeText}
                                texts={this.state.texts}
                            />
                        </div>
                    </div>
                </AlertProvider>
            </IntlProvider>
        );
    }
}

export default withAlert(App);



// WEBPACK FOOTER //
// ./src/App.js